module.exports = __webpack_public_path__ + "img/icon-cpu.9dae7294.png";